import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';
import { Card, CardContent } from '@/components/ui/card';

/**
 * Thin redirect wrapper for /r/:slug manage links
 * Exchanges slug for booking_id and redirects to BookingConfirmationPage in manage mode
 */
export default function ManageLinkRedirect() {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    async function exchangeAndRedirect() {
      try {
        if (!slug) {
          navigate('/');
          return;
        }

        const { data, error } = await supabase.functions.invoke('session-exchange', {
          body: { slug }
        });

        if (error || !data?.booking_id) {
          console.error('Session exchange failed:', error);
          navigate('/');
          return;
        }

        // Redirect to confirmation page in manage mode, preserving validated slug
        navigate(`/booking/confirmation/${data.booking_id}?mode=manage&slug=${slug}`);
      } catch (err) {
        console.error('Failed to exchange slug:', err);
        navigate('/');
      }
    }

    exchangeAndRedirect();
  }, [slug, navigate]);

  return (
    <div className="min-h-screen bg-gray-50 p-4 flex items-center justify-center">
      <Card className="w-full max-w-md">
        <CardContent className="py-12 text-center">
          <div className="text-sm text-muted-foreground">Loading booking details...</div>
        </CardContent>
      </Card>
    </div>
  );
}
